import { useEffect, useState } from 'react';

//Primereact components
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

// Column
import { ReportsColumns } from '../../appconfig/DatatableSetting';

// Data table

import AppBreadcrumb from '../../components/CustomeBreadcrumb/AppBreadcrumb';
import { useNavigate } from 'react-router-dom';
import { Badge } from 'primereact/badge';
import { getAction } from '../../appconfig/AppHelper';

export const FinancialReports = () => {
    document.title = 'Financial Reports | GSPC';
    const navigate = useNavigate();

    const [actions, setActions] = useState<any>([]);

    const [reportItmesLength, setReportsItemLength] = useState<any>();

    // use Effect method
    useEffect(() => {
        setActions(getAction('Financial Reports'));
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const reportsList = [
        {
            id: 0,
            name: 'Account Ledger',
            type: 'The Account Ledger Report provides a detailed record of all financial transactions associated with a specific account over a selected period. It includes debits, credits, opening and closing balances, and a running balance after each entry. ',
            report_name: {
                name: 'Financial Reports',
                count: reportItmesLength
            },
            link: '/app/report/financial/account-ledger'
        },
        {
            id: 1,
            name: 'Cash Book Detail',
            type: 'The Cash Book Detail Report provides a comprehensive, day-by-day record of all cash transactions within a specific period.',
            report_name: {
                name: 'Financial Reports'
            },
            link: '/app/report/financial/cashbook-detail'
        },
        {
            id: 2,
            name: 'Bank Book Detail',
            type: 'The Bank Book Detail Report provides a comprehensive, chronological record of all banking transactions within a specified date range. It includes detailed entries such as deposits, withdrawals,  bank charges and other related transactions.',
            report_name: {
                name: 'Financial Reports'
            },
            link: '/app/report/financial/bankbook-detail'
        },
        {
            id: 3,
            name: 'JV Book Detail',
            type: 'The JV (Journal Voucher) Book Detail Report provides a comprehensive breakdown of all journal entries recorded within a specified period.',
            report_name: {
                name: 'Financial Reports'
            },
            link: '/app/report/financial/jvbook-detail'
        },
        {
            id: 4,
            name: 'Trial Balance',
            type: 'The Trial Balance Report is an internal accounting document that lists all the general ledger accounts and their respective debit or credit balances at a specific point in time.',
            report_name: {
                name: 'Financial Reports'
            },
            link: '/app/report/financial/trial-balance'
        },
        {
            id: 5,
            name: 'Profit Loss Account',
            type: 'The Profit & Loss (P&L) Report provides a detailed summary of a company’s revenues, costs, and expenses over a specific period of time.',
            report_name: {
                name: 'Financial Reports'
            },
            link: '/app/report/financial/profit-and-lose-account'
        }
    ];

    const reportsItems = reportsList.filter((item) => item.name && Object.prototype.hasOwnProperty.call(actions, item.name));

    useEffect(() => {
        if (!window.cn(reportsItems)) {
            setReportsItemLength(reportsItems.length);
        }
    }, [reportsItems]);

    const headerTemplate = (data: any) => {
        return (
            <div className="flex align-items-center gap-2">
                <span className="font-bold">{data.report_name.name}</span>
                <Badge value={data.report_name.count}></Badge>
            </div>
        );
    };

    const onRowSelect = (event: any) => {
        navigate(event.data.link);
    };

    const nametemplate = (rowData: any) => {
        return <div style={{ color: '#408dfb', fontWeight: '600' }}>{rowData.name}</div>;
    };


    return (
        <>
            <AppBreadcrumb currentMenu={'Financial Reports'} pageName={'Financial Reports'} />
            <div className="grid crud-demo reports">
                <div className="col-12">
                    <div className="card">
                        <div className="col-12 header">
                            <h4 className="text-bold mb-0">All Reports</h4>
                        </div>
                        <DataTable
                            value={reportsItems}
                            className="datatable-responsive p-datatble-sm"
                            selectionMode="single"
                            onRowSelect={onRowSelect}
                            rowGroupMode="subheader"
                            rowGroupHeaderTemplate={headerTemplate}
                            groupRowsBy="report_name.name"
                            scrollable
                        >
                            {ReportsColumns.map((col, i) => {
                                if (col.field === 'name') {
                                    return <Column key={col.field} field={col.field} header={col.header} body={nametemplate} />;
                                } else {
                                    return <Column key={col.field} field={col.field} header={col.header} />;
                                }
                            })}
                        </DataTable>
                    </div>
                </div>
            </div>
        </>
    );
};
